import React from "react";
import { TextField, Button, Typography, Box } from "@mui/material";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router-dom";
import FooterNav from "./FooterNav";
import axiosInstance from "../AxiosBaseApi";

// Validation schema with Yup
const validationSchema = Yup.object({
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
  confirmpassword: Yup.string()
    .oneOf([Yup.ref('password'), null], "Passwords must match")
    .required("Confirm Password is required"),
});

const LoginPassword = () => {
  const navigate = useNavigate();

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const id = localStorage.getItem("mamberId");
      const response = await axiosInstance.post(
        `/bet.php?action=changepassword&user=${id}&password=${values.password}`
      );
      if (response.status === 200) {
        toast.success("Password successfully changed!");
        setTimeout(() => {
          resetForm();
          navigate("/personalinfo");
        }, 1000);
      } else {
        toast.error("Failed to change password. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      console.log("Error", error);
    }
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            padding: 1,
            justifyContent: "space-between",
            alignItems: "center",
            background: "#f83600",
            marginBottom: 1,
          }}
        >
          <Box onClick={() => navigate(-1)} style={{ textDecoration: "none" }}>
            <ChevronLeftIcon
              fontSize="medium"
              style={{
                color: "#fff",
                border: "1px solid #f2f3f5",
                borderRadius: 50,
              }}
            />
          </Box>
          <Typography variant="subtitle2" color="#fff">
            Change Password
          </Typography>
          <Box> </Box>
        </Box>

        <Box
          sx={{
            padding: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h4"
            color="secondary.light"
            gutterBottom
            sx={{ textAlign: "center" }}
          >
            Change Your Password
          </Typography>

          {/* Formik form */}
          <Formik
            initialValues={{
              password: "",
              confirmpassword: "",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, handleChange, touched, errors }) => (
              <Form
                style={{
                  background: "#fff",
                  borderRadius: "10px",
                  padding: "10px",
                  width: "80%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* Password Field */}
                <Field
                  as={TextField}
                  label="Old Password"
                  name="oldpassword"
                  size="small"
                  variant="outlined"
                  value={values.oldpassword}
                  onChange={handleChange}
                  fullWidth
                  type="password"
                  error={touched.oldpassword && Boolean(errors.oldpassword)}
                  helperText={touched.oldpassword && errors.oldpassword}
                  sx={{ marginBottom: 2 }}
                />
                <Field
                  as={TextField}
                  label="Login Password"
                  name="password"
                  size="small"
                  variant="outlined"
                  value={values.password}
                  onChange={handleChange}
                  fullWidth
                  type="password"
                  error={touched.password && Boolean(errors.password)}
                  helperText={touched.password && errors.password}
                  sx={{ marginBottom: 2 }}
                />
                <Field
                  as={TextField}
                  label="Confirm Password"
                  name="confirmpassword"
                  size="small"
                  variant="outlined"
                  value={values.confirmpassword}
                  onChange={handleChange}
                  fullWidth
                  type="password"
                  error={touched.confirmpassword && Boolean(errors.confirmpassword)}
                  helperText={touched.confirmpassword && errors.confirmpassword}
                  sx={{ marginBottom: 2 }}
                />
                {/* Submit Button */}
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ color: "#fff" }}
                >
                  Change Password
                </Button>
              </Form>
            )}
          </Formik>

          {/* Toast Notifications */}
          <ToastContainer />
        </Box>
      </div>
      <FooterNav />
    </>
  );
};

export default LoginPassword;
